define(function(require) {
	var IpsModel = require('civicsBase/ipsModel');

	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/portal/defaults/',

		url: function() {
			var instrumentType = this.get('instrumentType');
			var code = this.get('code');

			if (!instrumentType || !code) {
				return this.urlRoot;
			}

			// The instrument type is a clean path segment; the code is a query
			// parameter because type/license codes can contain URL-special
			// characters (e.g. '/', '.', spaces, '%', '#') that break path-segment
			// routing. The code is URL-encoded client-side.
			var url = this.urlRoot + encodeURIComponent(instrumentType)
				+ '?code=' + encodeURIComponent(code);

			var accountId = this.get('accountId');
			if (accountId != null && accountId !== '') {
				url += '&AccountId=' + parseInt(accountId, 10);
			}

			return url;
		},

		/**
		 * Guard: returns false if required params are missing,
		 * preventing the fetch from executing.
		 */
		canFetch: function() {
			var instrumentType = this.get('instrumentType');
			var code = this.get('code');
			return !!(instrumentType && code);
		},

		parse: function(response) {
			var raw = response?.data?.instrumentData;
			if (!raw) {
				return {};
			}
			if (typeof raw === 'string') {
				try {
					return JSON.parse(raw);
				} catch (e) {
					return {};
				}
			}
			return raw;
		}
	});
});
